import type { GetCookieRefreshTokenProps } from "../../lib/cookies/cookieRefreshToken.cookie";
import { getCookieRefreshToken } from "../../lib/cookies/cookieRefreshToken.cookie";

export type GetSessionRefreshTokenProps = GetCookieRefreshTokenProps;

export const getSessionRefreshToken = ({
  ...props
}: GetSessionRefreshTokenProps = {}) => ({
  refreshToken: getCookieRefreshToken(props),
});
